export default __webpack_public_path__ + "static/media/cuisineNegative.d1dff48b.webp";